import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const PriceCheckerPaymentCalculatorAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "price-checker-payment-calculator" */ './price-checker-payment-calculator'),
  componentName: 'PriceCheckerPaymentCalculator',
});
